module.exports = __webpack_public_path__ + "static/coffee_talk-8b04658c179640147b47b6fae2b4b318.webp";